import { Box, Skeleton, Stack } from '@mui/material'
import {
  TSubscription,
  TSubscriptionDetails,
} from '../../../../../core/types/CheckoutOrder'
import { maskCpfCnpjNumber } from '../../../../../masks/masks'
import { formatarPhone } from '../../../../../core/functions/phoneUtils'
import ListItemDefault from '../../../../../components/ListItem/ListItemDefault'

export interface IOrderDetailCustomerProp {
  checkoutOrder?: TSubscription
  details?: TSubscriptionDetails
  loading: boolean
}

const SubscriptionDetailCustomer = ({
  checkoutOrder,
  details,
  loading,
}: IOrderDetailCustomerProp) => {
  if (loading) {
    return (
      <Stack spacing={2} sx={{ p: 2 }}>
        <Skeleton variant="rounded" width="100%" height="45px" />
        <Skeleton variant="rounded" width="100%" height="45px" />
        <Skeleton variant="rounded" width="100%" height="45px" />
        <Skeleton variant="rounded" width="100%" height="45px" />
      </Stack>
    )
  }

  return (
    <Box>
      <ListItemDefault title="Nome" value={checkoutOrder?.name} />
      <ListItemDefault title="E-mail" value={checkoutOrder?.email} />
      <ListItemDefault
        title="Telefone"
        value={formatarPhone(
          details?.phone,
          details?.phoneCountryCode,
          details?.countryCode
        )}
      />
      <ListItemDefault
        title="CPF"
        value={maskCpfCnpjNumber(details?.orderDetails?.customerDocument)}
      />
    </Box>
  )
}

export default SubscriptionDetailCustomer
